import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  loadingDisable: false,
  loadingExport: false,
  users: [],
  pagination: {
    page: 1,
    limit: 25,
    total: -1,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    SET_LOADING: (s, data) => (s.loading = data),
    SET_LOADING_DISABLE: (s, data) => (s.loadingDisable = data),
    SET_LOADING_EXPORT: (s, data) => (s.loadingExport = data),
    SET_USERS: (s, data) => {
      s.users = data.users;
      s.pagination = data.pagination;
    },
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getPayIdUsers({ commit }, params) {
      commit("SET_LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/users", { params });
        const { data, pagination } = res.data;
        commit("SET_USERS", { users: data, pagination });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async exportPayIdUsers({ commit }, params) {
      commit("SET_LOADING_EXPORT", true);
      try {
        const res = await this.$api.get("/v1/portal/users", {
          params: { ...params, limit: 9999, page: 1 },
        });
        const { data } = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_EXPORT", false);
      }
    },

    async togglePayId({ commit }, { userId, disablePayId }) {
      commit("SET_LOADING_DISABLE", true);
      try {
        const res = await this.$api.put(
          `/v1/portal/users/${userId}/disable-pay-id`,
          { disablePayId }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
        throw e;
      } finally {
        commit("SET_LOADING_DISABLE", false);
      }
    },
  },
};
